// import React from 'react';
// import PDFViewer from './PDFViewer';
// import PropTypes from 'prop-types';
// import Loading from './loading/Loading';
import './css/bootstrap.min.css';
// import "./css/boardtrac-plus-app.css";
import './css/DocumentViewer.css';
// import MiniImage from './MiniImage';

import MainLayer from './MainLayer';
import ThumbnailsListView from './ThumbnailsListView';
import CommentsList from './CommentsList';
import * as constants from './helpers/constants';
import * as Icons from './SVGIcons';
if (!window._babelPolyfill) {
    require('babel-polyfill');
}
export { MainLayer, ThumbnailsListView, CommentsList, constants, Icons };

// export default class Loader extends React.Component {
//     constructor(props) {
//         super(props);
//
//         this.pdfViewer = null; // reference to pdf-viewer
//
//         this.state = {
//             url: null,
//             blob: null,
//             error: null,
//         };
//     }
//
//     componentWillMount() {
//         this.setFile();
//     }
//
//     setFile = (props = this.props) => {
//         let { blob, url } = props;
//         if (blob) {
//             // if blob passed just use it without fetching
//             this.setState({ blob, url });
//         } else {
//             // else fetching the file and create Blob from it
//             if (url) this.createBlobFromURL(url);
//         }
//     };
//
//     componentWillReceiveProps(props) {
//         this.setFile(props);
//     }
//
//     /**
//      * create blob from url and pass it to the next step
//      * @param url
//      */
//     createBlobFromURL = url => {
//         fetch(url)
//             .then(response => {
//                 if (response.status > 200) {
//                     throw new Error('bad status');
//                 }
//                 return response.blob();
//             })
//             .then(blob => {
//                 this.onDocumentReady(blob);
//             })
//             .catch(e => {
//                 console.log('Error', e);
//                 this.setState({ error: 'Error during fetching the document' });
//             });
//     };
//
//     /**
//      * put local url to state
//      * @param blob
//      */
//     onDocumentReady = blob => {
//         let blobUrl = URL.createObjectURL(blob);
//         this.setState({ blob: blobUrl });
//     };
//
//     render() {
//         if (this.state.error) {
//             return <div>Error during loading: {this.state.error}</div>;
//         }
//         if (!this.state.blob) {
//             return <Loading text={`Loading document ${this.props.fileName}`} />;
//         }
//         return (
//             <PDFViewer
//                 blob={this.state.blob}
//                 fileName={this.props.fileName}
//                 ref={component => (this.pdfViewer = component)}
//                 {...this.props}
//             />
//         );
//     }
// }
//
// Loader.propTypes = {
//     fileName: PropTypes.string,
//     url: PropTypes.string,
//     blob: PropTypes.string,
//     storeAdapter: PropTypes.shape({}),
//     onClose: PropTypes.func,
// };
//
// Loader.defaultProps = {
//     fileName: 'noname',
// };



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/index.js